/* MIWAU — JS definitivo v4 — Carrito AJAX Shopify */
var MW = {
  cart: function() {
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){MW.render(c);});
  },
  add: function(id, qty, btn) {
    if(btn){btn.disabled=true;}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:qty||1})})
    .then(function(r){return r.json();})
    .then(function(i){
      if(btn){btn.disabled=false;var o=btn.innerHTML;btn.innerHTML='✓ Añadido';btn.style.background='var(--gd)';setTimeout(function(){btn.innerHTML=o;btn.style.background='';},1600);}
      MW.toast('✓  '+i.product_title+' añadido al carrito');
      MW.openCart();
    }).catch(function(e){if(btn)btn.disabled=false;console.error(e);});
  },
  change: function(key, qty) {
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
    .then(function(r){return r.json();}).then(function(c){MW.render(c);});
  },
  render: function(c) {
    var list=document.getElementById('mw-cil');
    var foot=document.getElementById('mw-cft');
    var ups=document.getElementById('mw-cup');
    var badge=document.getElementById('mw-cb');
    if(badge){badge.textContent=c.item_count;badge.style.display=c.item_count>0?'flex':'none';}
    if(c.item_count===0){
      list.innerHTML='<div class="mw-cem">Tu carrito está vacío.<br>Añade algo para tu mascota 🐾</div>';
      if(foot)foot.style.display='none';if(ups)ups.style.display='none';return;
    }
    var html='';
    c.items.forEach(function(item){
      var img=item.image?'<img src="'+item.image+'" alt="'+item.product_title+'" style="width:100%;height:100%;object-fit:cover;">'
        :'<svg style="width:26px;height:26px;fill:none;stroke:currentColor;stroke-width:1.5;" viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
      var v=item.variant_title&&item.variant_title!=='Default Title'?'<div style="font-size:11px;color:var(--li);margin-bottom:3px;">'+item.variant_title+'</div>':'';
      html+='<div class="mw-cit"><div class="mw-cim">'+img+'</div><div class="mw-cii"><div class="mw-cin">'+item.product_title+'</div>'+v+'<div class="mw-cip">'+MW.fmt(item.line_price)+'</div><div class="mw-ciq"><button class="mw-ciqb" onclick="MW.change(\''+item.key+'\','+(item.quantity-1)+')">−</button><span class="mw-ciqn">'+item.quantity+'</span><button class="mw-ciqb" onclick="MW.change(\''+item.key+'\','+(item.quantity+1)+')">+</button></div></div><button class="mw-cir" onclick="MW.change(\''+item.key+'\',0)">Eliminar</button></div>';
    });
    list.innerHTML=html;
    var t=c.total_price;
    var sub=document.getElementById('mw-ctsub');var tot=document.getElementById('mw-cttot');var sh=document.getElementById('mw-ctsh');
    if(sub)sub.textContent=MW.fmt(t);if(tot)tot.textContent=MW.fmt(t);
    if(t>=5500){if(sh){sh.textContent='Gratis ';sh.className='free';}if(ups)ups.style.display='none';}
    else{if(sh){sh.textContent='Calculado al pagar';sh.className='';}var d=document.getElementById('mw-uamt');if(d)d.textContent=((5500-t)/100).toFixed(2).replace('.',',')+' €';if(ups)ups.style.display='flex';}
    if(foot)foot.style.display='block';
  },
  fmt: function(c){return(c/100).toFixed(2).replace('.',',')+' €';},
  openCart: function(){document.getElementById('mw-ov').classList.add('on');document.getElementById('mw-cd2').classList.add('on');document.body.style.overflow='hidden';MW.cart();},
  closeCart: function(){document.getElementById('mw-ov').classList.remove('on');document.getElementById('mw-cd2').classList.remove('on');document.body.style.overflow='';},
  toast: function(msg){var t=document.getElementById('mw-toast');var tx=document.getElementById('mw-toast-tx');if(!t||!tx)return;tx.textContent=msg;t.classList.add('on');setTimeout(function(){t.classList.remove('on');},2800);},
  wish: function(btn){btn.classList.toggle('on');},
  nl: function(){var e=document.getElementById('mw-nle');if(!e||!e.value.includes('@')){MW.toast('Introduce un email válido');return;}MW.toast('✓  Tu 10% de descuento está en camino');e.value='';},
    countdown: function(){
    // Contador gestionado por la sección banner de urgencia
    return;
  },
  reveal: function(){
    var els=document.querySelectorAll('.mw-pc,.mw-bc,.mw-rc,.mw-cc');
    var obs=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.style.opacity='1';e.target.style.transform='translateY(0)';obs.unobserve(e.target);}});},{threshold:0.08});
    els.forEach(function(el){el.style.opacity='0';el.style.transform='translateY(18px)';el.style.transition='opacity .5s ease,transform .5s ease';obs.observe(el);});
  },
  variantSelect: function(){
    document.querySelectorAll('.mw-vob').forEach(function(btn){
      btn.addEventListener('click',function(){
        var g=this.closest('.mw-vo');g.querySelectorAll('.mw-vob').forEach(function(b){b.classList.remove('on');});this.classList.add('on');
        var f=this.closest('form');if(f){var hid=f.querySelector('[name="id"]');if(hid&&this.dataset.vid)hid.value=this.dataset.vid;}
      });
    });
    var qm=document.getElementById('mw-qminus'),qp=document.getElementById('mw-qplus'),qn=document.getElementById('mw-qnum'),qh=document.getElementById('mw-qhid');
    if(qm&&qp&&qn){
      qm.addEventListener('click',function(){var v=parseInt(qn.textContent)||1;if(v>1){qn.textContent=v-1;if(qh)qh.value=v-1;}});
      qp.addEventListener('click',function(){var v=parseInt(qn.textContent)||1;qn.textContent=v+1;if(qh)qh.value=v+1;});
    }
    document.querySelectorAll('.mw-gal-th').forEach(function(th){
      th.addEventListener('click',function(){
        document.querySelectorAll('.mw-gal-th').forEach(function(t){t.classList.remove('on');});this.classList.add('on');
        var mi=document.querySelector('.mw-gal-main img');if(mi&&this.dataset.full)mi.src=this.dataset.full;
      });
    });
    document.querySelectorAll('.mw-pdp-ajax').forEach(function(form){
      form.addEventListener('submit',function(e){
        e.preventDefault();
        var id=form.querySelector('[name="id"]').value;
        var qty=form.querySelector('[name="quantity"]')?parseInt(form.querySelector('[name="quantity"]').value):1;
        var btn=form.querySelector('.mw-btn-cart');
        MW.add(id,qty,btn);
      });
    });
  }
};

function openCart(){MW.openCart();}
function closeCart(){MW.closeCart();}
document.addEventListener('keydown',function(e){if(e.key==='Escape')MW.closeCart();});
document.addEventListener('DOMContentLoaded',function(){MW.countdown();MW.reveal();MW.variantSelect();});
